import * as storeAnalytics from './views/store/analytics.js';
import createMetrikaClientAdapter from './controllers/adapters/metrika/metrika.client.js';

const ADAPTER_FACTORIES = {
  metrika: createMetrikaClientAdapter,
  // ga4: createGa4ClientAdapter,  // позже
};

function instantiateAdapters(adaptersOption = []) {
  const result = [];
  for (const item of adaptersOption) {
    if (!item) continue;
    // Уже готовый instance (есть getContext / install)
    if (typeof item.getContext === 'function' || typeof item.install === 'function') {
      result.push(item);
      continue;
    }
    // Plain config: { name: 'metrika', counterId, ... }
    const factory = ADAPTER_FACTORIES[item.name];
    if (!factory) {
      console.warn(`[analytics] no client adapter factory for "${item.name}"`);
      continue;
    }
    try {
      result.push(factory(item));
    } catch (e) {
      console.error(`[analytics] failed to create adapter "${item.name}":`, e?.message);
    }
  }
  return result;
}

function initializeAnalytics(app, store, router, options = {}) {
  // martyrs core пробрасывает модуль-специфичный конфиг через `options.settings`
  // (см. ModuleManager.register / core.app.js — там сохраняется поле `settings`
  // из global.config.modules.<name>.settings).
  const adapters = instantiateAdapters(options.settings?.adapters || []);

  // НЕ регистрируем store через core `store.addStore` — это включает analytics
  // в SSR-сериализацию initialState, и при гидратации `setInitialState` с пустыми
  // server-side значениями (window нет → install не выполнился на сервере)
  // затирает только что установленный клиентский state. Композаблы напрямую
  // импортируют actions из views/store/analytics.js — core.store не нужен.

  // install адаптеров (подгрузка скриптов, capture своих параметров)
  // и старт сессии. Делаем ТОЛЬКО на клиенте.
  if (typeof window !== 'undefined') {
    storeAnalytics.actions.install({ adapters });
  }
}

export {
  storeAnalytics,
  initializeAnalytics as initialize,
  createMetrikaClientAdapter,
};

// Удобный импорт actions для прямого использования в компонентах:
//   import { useAnalytics } from '@ozdao/martyrs/modules/analytics/client';
//   const analytics = useAnalytics();
//   analytics.track('csp_open', { source: 'searches_button' });
export function useAnalytics() {
  return storeAnalytics.actions;
}

export default {
  initialize: initializeAnalytics,
  useAnalytics,
  storeAnalytics,
  createMetrikaClientAdapter,
};
